import { cn } from "@lib/cn";
import Icon from "@/components/ui/icon";

const DialogBaseComponent = ({ children }: { children: React.ReactNode }) => (
  <div className="tw-rounded-lg tw-bg-white tw-shadow-dialog">{children}</div>
);

const DialogBaseHeader = ({
  title,
  onClose,
}: {
  title: string;
  onClose: () => void;
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-rounded-t-lg tw-border-b tw-border-solid tw-border-blue-100 tw-p-6">
      <span className="tw-font-sans tw-text-base tw-font-semibold tw-text-blue">
        {title}
      </span>
      <span
        className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center"
        onClick={onClose}
      >
        <Icon
          icon="ri-close-line"
          className="tw-text-2xl tw-text-blue-500 tw-transition-colors hover:tw-text-blue-800"
        />
      </span>
    </div>
  );
};

const DialogBaseContent = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("tw-w-[512px] tw-px-6 tw-pb-14 tw-pt-8", className)}>
      {children}
    </div>
  );
};

const DialogBaseFooter = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-rounded-b-lg tw-border-t tw-border-solid tw-border-blue-100 tw-bg-blue-50 tw-px-4 tw-py-[14px]">
      {children}
    </div>
  );
};

const DialogBase = Object.assign(DialogBaseComponent, {
  Header: DialogBaseHeader,
  Content: DialogBaseContent,
  Footer: DialogBaseFooter,
});

export { DialogBase };
